module.exports = "<div id=\"maintree\">\r\n  <p-tree [value]=\"lstDanhMucRoot\" styleClass=\"maintree\" [loading]=\"IsLoadingChild\" selectionMode=\"single\" (onNodeSelect)=\"nodeSelect($event)\" (onNodeExpand)=\"nodeExpand($event)\" [(selection)]=\"selectedFiles\">\r\n \r\n  </p-tree>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/cay-thu-muc-new/caythumuc.component.html
// module id = ../../../../../src/app/share/cay-thu-muc-new/caythumuc.component.html
// module chunks = main